export const Method = {
    POST : 'post',
    GET : 'get',
    PUT : 'put',
    DELETE : 'delete',
}

export const ServicePath = {
    AuthOidc : '/api/v1/loginOidc',
    AuthThinkAdmin : '/api/v1/login',
    GetUser : '/api/v1/user',
    AppList : '/api/v1/routes',
    PermissionList : '/api/v1/permissions',
    SearchUser : '/work/v3/portal-management',
    GroupCreate : '/api/v1/group',
    GroupList : '/api/v1/groups',
    GroupById : '/api/v1/group',
    AddUserToGroup : '/api/v1/addUserGroup',
    AddAppToGroup : '/api/v1/addAppGroup',
    DeleteUserInGroup : '/api/v1/delUserGroup',
    DeleteAppInGroup : '/api/v1/delAppGroup',
    DeleteGroup : '/api/v1/group',
    UserRoles: '/api/v1/userroles',
    UserRole: '/api/v1/userrole',
    DeleteUser: '/api/v1/user'
}

export const Roles = {
    SUPER : 'super',
    ADMIN : 'admin',
    MEMBER : 'member',
    REPORTER : 'reporter',
}

export const Token = 'Token'